import React from "react";
import Pagetitle from "../elements/Pagetitle";
import Timeline from "../elements/Timeline";

const educationData = [
	{
		id: 1,
		title: "P.h.D in Stats/Machine Learning",
		location: "University Paris Saclay",
		years: "2020-2023",
		content: "",
	},
	{
		id: 1,
		title: "Master’s degree 2, Statistics",
		location: "Sorbonne University (Ex UPMC)",
		years: "2018-2019",
		content: "",
	},
	{
		id: 1,
		title: "Bachelor’s degree, Mathematics",
		location: "Sorbonne University (Ex UPMC)",
		years: "2015-2018",
		content: "",
	},
];

const experienceData = [
	{
		id: 0,
		title: "AI Research Scientist | Vice President",
		location: "J.P. Morgan AI Research",
		years: "2023 - Now",
		content: "",
	},
	// {
	// 	id: 1,
	// 	title: "Data Scientist Consultant",
	// 	location: "Quantmetry",
	// 	years: "2021",
	// 	content:
	// 		"Maintaining ACV in SHAPASH (MAIF’s XAI tools), and give assistance on XAI problems at Quantmetry.",
	// },
	{
		id: 2,
		title: "Research Scientist in Explainable AI",
		location: "Groupe PSA",
		years: "2020",
		content:
			"Physics-based deep learning to make neural networks more interpretable.",
	},
	{
		id: 3,
		title: "Research Intern in Computer Vision",
		location: "Dassault Systèmes",
		years: "2019",
		content:
			"Unsupervised learning for the generation and edition of 3D objects (Point clouds, Mesh) with Deep Learning.",
	},
	{
		id: 4,
		title: "Research Intern in Computer Vision",
		location: "Techway",
		years: "2018",
		content:
			"Develop deep learning models for anomaly detection on FPGA chips.",
	},
	{
		id: 5,
		title: "Research Intern in Probability",
		location: "LPSM - Sorbonne University (Ex UPMC)",
		years: "2017",
		content:
			"Theoretical analysis of branching random walk with applications for biological process.",
	},
];

function Experiences() {
	return (
		<section id="experience">
			<div className="container">
				<Pagetitle title="Experience" />
				<div className="row">
					<div className="col-md-12">
						<div className="timeline-horizontal">
							<div className="timeline-section">
								<h4 className="timeline-section-title">Education</h4>
								<div className="timeline-items">
									{educationData.map((education) => (
										<div key={education.id} className="timeline-item-horizontal">
											<Timeline education={education} />
										</div>
									))}
								</div>
							</div>
							<div className="timeline-section">
								<h4 className="timeline-section-title">Work Experience</h4>
								<div className="timeline-items">
									{experienceData.map((experience) => (
										<div key={experience.id} className="timeline-item-horizontal">
											<Timeline education={experience} />
										</div>
									))}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}

export default Experiences;
